import { NgModule } from '@angular/core';
import { ZefTranslationsService } from '@zerops/zef/translations';
import { FEATURE_NAME } from './debug-switcher.constant';

const en = {

};

export type DebugSwitcherTranslations = typeof en;

@NgModule()
export class DebugSwitcherTranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
